import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import SignaturePad from "react-signature-canvas"
import { Button } from "../Button/Button"
import { Wrapper } from "./SignaturePad.style"

interface IProps {
  onSave: (sign: any) => void
  isLoading?: boolean
  sign?: string
  signType?: "date" | "name" | "onlyDate" | "both"
  dateSign?: string
  isDateSignatureChecked?: boolean
  DEFAULT_DATE_SIGNATURE_PAD_IMAGE: string
}
export const SignatureCanvas: React.FC<IProps> = ({
  onSave,
  isLoading,
  sign,
  dateSign,
  signType,
  DEFAULT_DATE_SIGNATURE_PAD_IMAGE,
}) => {
  const { t } = useTranslation()
  const signCanvasRef = React.useRef<any>()
  const dateCanvasRef = React.useRef<any>()
  const [clearSign, setClearSign] = useState({
    dateSign: false,
    sign: false,
  })
  const [isDateSign, setIsDateSign] = useState(
    signType == "date" || signType == "onlyDate",
  )
  const clearSignature = () => {
    if (signCanvasRef) {
      signCanvasRef?.current?.clear()
    }
    dateCanvasRef?.current?.clear()
    dateCanvasRef?.current?.fromDataURL(DEFAULT_DATE_SIGNATURE_PAD_IMAGE, {
      width: 480,
      height: 80,
    })
    setClearSign({
      dateSign: true,
      sign: true,
    })
    setIsDateSign(false)
  }
  const clearSignSignature = () => {
    if (signCanvasRef) {
      signCanvasRef?.current?.clear()
    }
    setClearSign({
      ...clearSign,
      sign: true,
    })
  }
  const clearDateSignature = () => {
    setClearSign({
      ...clearSign,
      dateSign: true,
    })
    dateCanvasRef?.current?.clear()
    dateCanvasRef?.current?.fromDataURL(DEFAULT_DATE_SIGNATURE_PAD_IMAGE, {
      width: 480,
      height: 80,
    })
  }
  useEffect(() => {
    if (signCanvasRef?.current != undefined) {
      signCanvasRef?.current.fromDataURL(sign, { width: 480, height: 250 })
    }
    dateCanvasRef?.current?.fromDataURL(
      dateSign || DEFAULT_DATE_SIGNATURE_PAD_IMAGE,
      {
        width: 480,
        height: 80,
      },
    )
  }, [sign, dateSign])

  const saveSignature = async () => {
    const sign = signCanvasRef?.current
      ?.getTrimmedCanvas()
      .toDataURL("image/png")

    if (isDateSign) {
      const dateSignature = dateCanvasRef.current
        .getTrimmedCanvas()
        .toDataURL("image/png")
      onSave(clearSign?.dateSign ? "" : dateSignature)
    } else {
      onSave(clearSign?.sign ? "" : sign)
    }
    setIsDateSign(false)
  }

  const renderPad = (type) => {
    switch (type) {
      case "name":
        return (
          <div className={"pad"}>
            <SignaturePad
              ref={signCanvasRef}
              canvasProps={{
                width: 480,
                height: 250,
                className: "sigCanvas",
              }}
              onEnd={() => {
                setClearSign({
                  ...clearSign,
                  sign: false,
                })
              }}
            />
            <span
              style={{
                pointerEvents: "none",
              }}
            >
              {t("Sign")}
            </span>
            <Button
              onClick={clearSignSignature}
              type={"default"}
              danger
              btnText={t("Clear")}
              height={"20px"}
            />
          </div>
        )
      case "date":
        return (
          <div className={"date__signature_pad_container"}>
            <SignaturePad
              ref={dateCanvasRef}
              penColor={"#3f3f3d"}
              velocityFilterWeight={0.2}
              maxWidth={1}
              throttle={10}
              canvasProps={{
                width: 480,
                height: 80,
                className: "sigCanvas",
              }}
              onEnd={() => {
                setIsDateSign(true)
                setClearSign({
                  ...clearSign,
                  dateSign: false,
                })
              }}
            />

            <Button
              onClick={clearDateSignature}
              type={"default"}
              danger
              btnText={t("Clear")}
            />
          </div>
        )
      default:
        return null
    }
  }

  return (
    <Wrapper signType={signType}>
      <div className={"pad-container"}>{renderPad(signType)}</div>
      <div className={"btns-container"}>
        <Button
          onClick={clearSignature}
          type={"default"}
          danger
          btnText={t("Clear all")}
          shape={"round"}
          disabled={isLoading}
        />
        <Button
          onClick={saveSignature}
          isLoading={isLoading}
          btnText={t("Save")}
          shape={"round"}
        />
      </div>
    </Wrapper>
  )
}
